import { invoiceModel } from "../../models";
import { integrationsModel } from "../../models/integrations";
import { userSelectors } from "./userSelectors";

const integrations = s => s.integrations.data;

const qboIntegration = s => integrationsModel.qboIntegration(integrations(s));

const isLinkedToQbo = s => {
  var _qboIntegration;

  return ((_qboIntegration = qboIntegration(s)) === null || _qboIntegration === void 0 ? void 0 : _qboIntegration.status) === 'linked';
};

const showQboIntegration = s => isLinkedToQbo(s) && userSelectors.isVendor(s);

const isPendingQboIntegrationSetup = s => {
  var _qboIntegration$accou, _qboIntegration2;

  const accountsList = Object.values((_qboIntegration$accou = (_qboIntegration2 = qboIntegration(s)) === null || _qboIntegration2 === void 0 ? void 0 : _qboIntegration2.accounts) !== null && _qboIntegration$accou !== void 0 ? _qboIntegration$accou : {});
  const isValidAccountsLength = accountsList.length === 3;
  const areAllAccountsSynced = accountsList.every(account => Boolean(account.synced));
  return !isValidAccountsLength || !areAllAccountsSynced;
};

const qboCustomTxnNumbers = s => {
  var _qboIntegration3;

  return (_qboIntegration3 = qboIntegration(s)) === null || _qboIntegration3 === void 0 ? void 0 : _qboIntegration3.qboSettings.customTxnNumbers;
};

const qboInProgress = s => {
  var _qboIntegration4;

  return ((_qboIntegration4 = qboIntegration(s)) === null || _qboIntegration4 === void 0 ? void 0 : _qboIntegration4.dataSyncStatus) === 'inProgress';
};

const showInvoiceQboSection = (relationship, invoice) => s => !!(showQboIntegration(s) && !isPendingQboIntegrationSetup(s) && userSelectors.isVendorInRelationship(relationship)(s) && invoiceModel.integration(invoice));

export const integrationSelectors = {
  integrations,
  qboIntegration,
  isLinkedToQbo,
  showQboIntegration,
  isPendingQboIntegrationSetup,
  qboCustomTxnNumbers,
  qboInProgress,
  showInvoiceQboSection
};